import GoogleMapsLoader from 'google-maps';
GoogleMapsLoader.KEY = 'AIzaSyCrSQz2CPPw1C0NLJ7-6Dd61MErqtkdeMs';

export default {
  init() {
    // JavaScript to be fired on the about us page
    GoogleMapsLoader.load(function(google) {

        //default center of map
        var center = {lat: -38.630373049390855, lng: 176.09571682006833};
        //creating map
        var map = new google.maps.Map(document.getElementById('MainMap'), {
            zoom: 14,
            center: center,
        });
        //create info window
        var infowindow = new google.maps.InfoWindow();
        //get attractions
        var attractions = window.attractions;
        // loop through attractions and create markers and info windows
        attractions.forEach(element => {

            var center = {lat: parseFloat(element.lat), lng: parseFloat(element.lng)};
            var marker = new google.maps.Marker({
                position: center,
                map: map,
            });

            var content = buildInfoContent(element);

            google.maps.event.addListener(marker,'click', (function(marker,content,infowindow){ 
                return function() {
                    infowindow.setContent(content);
                    infowindow.open(map,marker);
                };
            })(marker,content,infowindow)); 

        });

        function buildInfoContent(attraction) {
            //wrapper
            var info = document.createElement("div");
            info.classList.add('info-window');
            //heading
            var h = document.createElement("h4");
            h.innerHTML = attraction.name;
            //blurb
            var p = document.createElement("p");
            p.innerHTML = attraction.blurb;
            //link
            var a = document.createElement("a");
            a.href = attraction.link;
            a.innerHTML = "Check it out";
            a.classList.add("btn", "btn-primary");
            //build and return full content
            info.appendChild(h);
            info.appendChild(p);
            info.appendChild(a);
            return info;
        }

    });
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/map.js